



// // src/SideBarComponents/DataSources/EditDataSourcesPage.tsx

// import React, { useState, useMemo, useEffect } from 'react';
// import {
//   Box, Typography, Button, TextField, RadioGroup, FormControlLabel,
//   Radio, Paper, Divider, InputLabel, CircularProgress, Alert,
//   Dialog, DialogContent, DialogActions,
// } from '@mui/material';
// import { useTheme, alpha } from '@mui/material/styles';
// import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';
// import { useNavigate, useParams, useOutletContext } from 'react-router-dom';
// import { gql, useMutation, useQuery, useLazyQuery } from '@apollo/client';
// import type { Tenant } from '../../App';

// export enum GQLProviderType {
//   GCP = "GCP",
//   AWS = "AWS",
//   AZURE = "Azure",
// }

// // --- Reusable Error Dialog Component ---
// const ErrorDialog = ({ open, onClose, title, message }: { open: boolean, onClose: () => void, title: string, message: string }) => {
//   if (!open) return null;
//   return (
//       <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: '16px', width: '100%', maxWidth: '500px', height:'370px',p: 2 } }}>
//           <DialogContent sx={{ textAlign: 'center', p: { xs: 2, sm: 3 } }}>
//               <Box
//                   sx={{
//                       mx: 'auto', mb: 2, width: 56, height: 56, borderRadius: '50%',
//                       display: 'flex', alignItems: 'center', justifyContent: 'center',
//                       backgroundColor: (theme) => alpha(theme.palette.error.main, 0.1),
//                   }}
//               >
//                   <ErrorOutlineIcon color="error" sx={{ fontSize: 32 }} />
//               </Box>
//               <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>{title}</Typography>
//               <Typography variant="body1" color="text.secondary" sx={{whiteSpace: 'pre-line'}}>
//                   {message}
//               </Typography>
//           </DialogContent>
//           <DialogActions sx={{ p: '0 24px 24px', mt: 2 }}>
//               <Button onClick={onClose} variant="contained" fullWidth size="large" sx={{ background:'#0064FF',color:'#FFFFFF', textTransform: 'none', py: 1.5, borderRadius: '8px' }}>
//                   Got It
//               </Button>
//           </DialogActions>
//       </Dialog>
//   );
// };

// // --- GraphQL Definitions ---
// const GET_DATA_SOURCE_FOR_EDIT = gql`
//   query GetDataSourceForEdit($dataSourceId: ID!) {
//     dataSourceById(id: $dataSourceId) {
//       id
//       name
//       providerType
//       billingAccountId
//       billingConfig
//       tenantId
//     }
//   }
// `;

// const GET_TENANT_PROVIDER_ACCESS = gql`
//   query GetTenantProviderAccess($tenantId: ID!, $providerType: ProviderType!) {
//     getTenantProviderAccess(tenantId: $tenantId, providerType: $providerType) {
//       serviceAccountEmail
//     }
//   }
// `;

// const UPDATE_DATA_SOURCE_MUTATION = gql`
//   mutation EditDataSource($id: ID!, $input: EditDataSourceInput!) {
//     editDataSource(id: $id, input: $input) {
//       id
//     }
//   }
// `;

// const VALIDATE_NEW_DATA_SOURCE_CREDENTIALS_MUTATION = gql`
//   mutation ValidateNewDataSourceCredentials($input: ValidateNewDataSourceCredentialsInput!) {
//     validateNewDataSourceCredentials(input: $input) { isValid validationErrors }
//   }
// `;
  
// // --- Interfaces ---
// interface DataSourceForEdit {
//     id: string;
//     name: string;
//     providerType: string;
//     billingAccountId: string;
//     tenantId: string;
//     billingConfig: {
//         bigQueryProjectId: string;
//         bigQueryDatasetId: string;
//         bigQueryDataTableName: string;
//     } | null;
// }

// interface EditDataSourceOutletContext {
//   currentTenant: Tenant | null;
// }

// const mapGqlToProviderValue = (gqlProvider: string): string => {
//     switch(gqlProvider) {
//         case 'GCP': return 'google-cloud-platform';
//         case 'AWS': return 'aws';
//         case 'AZURE': return 'azure';
//         default: return 'google-cloud-platform';
//     }
// };

// const mapProviderToGqlType = (frontendProviderValue: string): GQLProviderType => {
//   switch (frontendProviderValue) {
//     case 'google-cloud-platform': return GQLProviderType.GCP;
//     case 'aws': return GQLProviderType.AWS;
//     case 'azure': return GQLProviderType.AZURE;
//     default: throw new Error(`Unsupported provider value: ${frontendProviderValue}`);
//   }
// };

// const EditDataSourcesPage: React.FC = () => {
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const { dataSourceId } = useParams<{ dataSourceId: string }>();
//   const { currentTenant } = useOutletContext<EditDataSourceOutletContext>();
//   const activeTenantId = currentTenant?.id;

//   // Form State
//   const [name, setName] = useState('');
//   const [billingAccountId, setBillingAccountId] = useState('');
//   const [bigQueryProjectId, setBigQueryProjectId] = useState('');
//   const [bigQueryDatasetId, setBigQueryDatasetId] = useState('');
//   const [bigQueryDataTableName, setBigQueryDataTableName] = useState('');
//   const [selectedProvider, setSelectedProvider] = useState('google-cloud-platform');
//   const [originalTenantId, setOriginalTenantId] = useState<string | null>(null);
  
//   const [fieldErrors, setFieldErrors] = useState({
//     name: '',
//     billingAccountId: '',
//     bigQueryProjectId: '',
//     bigQueryDatasetId: '',
//     bigQueryDataTableName: '',
//   });
  
//   const [serviceAccountEmail, setServiceAccountEmail] = useState<string | null>(null);
//   const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
//   const [errorDialogContent, setErrorDialogContent] = useState({ title: '', message: '' });

//   // --- GraphQL Hooks ---
//   const { loading: queryLoading, error: queryError } = useQuery<{ dataSourceById: DataSourceForEdit }>(GET_DATA_SOURCE_FOR_EDIT, {
//     variables: { dataSourceId },
//     skip: !dataSourceId,
//     onCompleted: (data) => {
//         if (data.dataSourceById) {
//             const ds = data.dataSourceById;
//             setName(ds.name);
//             setBillingAccountId(ds.billingAccountId);
//             setSelectedProvider(mapGqlToProviderValue(ds.providerType));
//             setOriginalTenantId(ds.tenantId);
//             setBigQueryProjectId(ds.billingConfig?.bigQueryProjectId || '');
//             setBigQueryDatasetId(ds.billingConfig?.bigQueryDatasetId || '');
//             setBigQueryDataTableName(ds.billingConfig?.bigQueryDataTableName || '');
//         }
//     }
//   });

//   const [getTenantAccess, { loading: saLoading, error: saError }] = useLazyQuery(GET_TENANT_PROVIDER_ACCESS);
//   const [updateDataSource, { loading: updateLoading }] = useMutation(UPDATE_DATA_SOURCE_MUTATION);
//   const [validateCredentials, { loading: validateLoading }] = useMutation(VALIDATE_NEW_DATA_SOURCE_CREDENTIALS_MUTATION);

//   useEffect(() => {
//     if (activeTenantId && selectedProvider === 'google-cloud-platform') {
//         getTenantAccess({
//             variables: {
//                 tenantId: activeTenantId,
//                 providerType: GQLProviderType.GCP
//             },
//             onCompleted: (data) => {
//                 setServiceAccountEmail(data.getTenantProviderAccess?.serviceAccountEmail || null);
//             }
//         });
//     }
//   }, [activeTenantId, selectedProvider, getTenantAccess]);

//   const stepsData = useMemo(() => [
//     { step: 'STEP 1', title: 'Enable billing export to BigQuery', description: 'Go to Billing > Billing Export > Export to BigQuery > Choose Dataset' },
//     { 
//       step: 'STEP 2', 
//       title: 'Assign Roles to Service Account', 
//       description: serviceAccountEmail 
//         ? `Give the following roles:\n * BigQuery Data Viewer\n * BigQuery Job User\nTo: The service account (${serviceAccountEmail})`
//         : (saLoading ? 'Fetching service account details...' : 'Could not retrieve service account.') 
//     },
//     { step: 'STEP 4', title: 'Provide the following information below', description: 'Enter your GCP credentials and dataset details' },
//   ], [serviceAccountEmail, saLoading]);

//   // MODIFICATION: Implemented the validation logic.
//   const validateField = (name: string, value: string): string => {
//     switch (name) {
//       case 'name':
//         if (!/^[a-z0-9\s]{2,50}$/.test(value)) return 'Must be 2-50 chars, lowercase letters, numbers, spaces.';
//         break;
//       case 'billingAccountId':
//         if (!/^[0-9A-F]{6}-[0-9A-F]{6}-[0-9A-F]{6}$/i.test(value)) return 'Format: XXXXXX-XXXXXX-XXXXXX (hex digits).';
//         break;
//       case 'bigQueryProjectId':
//         if (!/^[a-z][a-z0-9-]{4,28}[a-z0-9]$/.test(value)) return '6-30 chars, starts with letter, ends with letter/num, only lowercase, nums, hyphens.';
//         break;
//       case 'bigQueryDatasetId':
//         if (!/^[a-zA-Z][a-zA-Z0-9_]{0,1023}$/.test(value)) return '1-1024 chars, starts with letter, only letters, nums, underscores.';
//         break;
//       case 'bigQueryDataTableName':
//         if (!/^[a-zA-Z_][a-zA-Z0-9_-]{0,1023}$/.test(value)) {
//           return '1-1024 chars, starts with letter or underscore, can only contain letters, nums, underscores, or hyphens.';
//         }
//         const prefixes = ['_table_', '_file_', '_partition_'];
//         if (prefixes.some(p => value.toLowerCase().startsWith(p))) {
//           return 'Cannot start with _TABLE_, _FILE_, or _PARTITION_.';
//         }
//         break;
//       default:
//         break;
//     }
//     return '';
//   };

//   const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const { name: fieldName, value } = event.target;
//     let errorMessage = '';

//     switch (fieldName) {
//       case 'name': setName(value); errorMessage = validateField(fieldName, value); break;
//       case 'billingAccountId': setBillingAccountId(value); errorMessage = validateField(fieldName, value); break;
//       case 'bigQueryProjectId': setBigQueryProjectId(value); errorMessage = validateField(fieldName, value); break;
//       case 'bigQueryDatasetId': setBigQueryDatasetId(value); errorMessage = validateField(fieldName, value); break;
//       case 'bigQueryDataTableName': setBigQueryDataTableName(value); errorMessage = validateField(fieldName, value); break;
//       default: break;
//     }
//     setFieldErrors(prev => ({ ...prev, [fieldName]: errorMessage }));
//   };
  
//   const canSubmit = useMemo(() => (
//     name.trim() !== '' && billingAccountId.trim() !== '' &&
//     bigQueryProjectId.trim() !== '' && bigQueryDatasetId.trim() !== '' && bigQueryDataTableName.trim() !== '' &&
//     Object.values(fieldErrors).every(error => error === '')
//   ), [name, billingAccountId, bigQueryProjectId, bigQueryDatasetId, bigQueryDataTableName, fieldErrors]);

//   // MODIFICATION: Implemented the submission logic.
//   const handleSubmit = async () => {
//     if (!canSubmit || !dataSourceId) return;

//     // Use the tenantId that the data source originally belongs to for validation and update.
//     const validationInput = {
//         name: name.trim(),
//         tenantId: originalTenantId,
//         providerType: mapProviderToGqlType(selectedProvider),
//         billingAccountId: billingAccountId.trim(),
//         bigQueryProjectId: bigQueryProjectId.trim(),
//         bigQueryDatasetId: bigQueryDatasetId.trim(),
//         bigQueryDataTableName: bigQueryDataTableName.trim(),
//     };

//     try {
//         const validationResponse = await validateCredentials({
//             variables: { input: validationInput },
//         });

//         const validationResult = validationResponse.data?.validateNewDataSourceCredentials;

//         if (!validationResult?.isValid) {
//             const errorsArray = (validationResult.validationErrors as any)?.errors;
//             const message = (Array.isArray(errorsArray) && errorsArray.length > 0) 
//                 ? errorsArray.join('\n') 
//                 : "The details provided are not valid. Please check them and try again.";

//             setErrorDialogContent({ title: "Validation Failed", message });
//             setIsErrorDialogOpen(true);
//             return;
//         }

//         const updateInput = {
//             name: name.trim(),
//             billingAccountId: billingAccountId.trim(),
//             bigQueryProjectId: bigQueryProjectId.trim(),
//             bigQueryDatasetId: bigQueryDatasetId.trim(),
//             bigQueryDataTableName: bigQueryDataTableName.trim(),
//         };

//         const updateResponse = await updateDataSource({
//             variables: { id: dataSourceId, input: updateInput },
//         });

//         if (updateResponse.errors) {
//             setErrorDialogContent({
//                 title: "Error Saving Changes",
//                 message: updateResponse.errors[0].message,
//             });
//             setIsErrorDialogOpen(true);
//             return;
//         }

//         navigate('/data-sources', { state: { dataSourceUpdated: true } });

//     } catch (e: any) {
//         setErrorDialogContent({
//             title: "An Unexpected Error Occurred",
//             message: e.message || 'An unknown error occurred.',
//         });
//         setIsErrorDialogOpen(true);
//     }
//   };

//   const externalLabelStyle = { fontFamily: 'Inter, sans-serif', fontSize: '12px', fontWeight: 400, color: theme.palette.text.primary, marginBottom: theme.spacing(0.75), display: 'block' };
//   const sxTextField = { '& .MuiOutlinedInput-root': { '& fieldset': { borderRadius: '8px' } }, '& .MuiInputBase-input': { fontFamily: 'Inter, sans-serif', color: theme.palette.text.primary, fontSize: '12px' }, '& .MuiInputBase-input::placeholder': { fontFamily: 'Inter, sans-serif', color: 'rgba(185, 185, 185, 1)', fontSize: '12px', opacity: 1 } };
//   const handleGoBack = () => navigate('/data-sources');
//   const handleProviderChange = (event: React.ChangeEvent<HTMLInputElement>) => setSelectedProvider(event.target.value);

//   const isSubmitting = updateLoading || validateLoading;

//   if (queryLoading) return <Box sx={{display: 'flex', justifyContent: 'center', p:4}}><CircularProgress /></Box>
//   if (queryError) return <Alert severity="error">Error loading data for editing: {queryError.message}</Alert>

//   return (
//     <Box sx={{ p: { xs: 2, sm: 3 } }}>
//       <Box sx={{ mb: 2, flexShrink: 0 }}>
//         <Button
//           onClick={handleGoBack}
//           startIcon={<img src="/icons/back-arrow.svg" alt="Back" style={{ width: '12px', height: '12px' }} />}
//           sx={{ p: 0, textTransform: 'none', color: 'text.primary', '&:hover': { backgroundColor: 'transparent' } }}
//         >
//           <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px', marginLeft:'4px' }}>
//             Edit Data Source
//           </Typography>
//         </Button>
//         <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: '12px', color: 'rgba(102, 102, 102, 1)', mt: 0.5,marginRight:10, marginLeft:2 }}>
//           Update the Billing Account IDs and linked BigQuery dataset details.
//         </Typography>
//       </Box>

//       <Paper 
//         elevation={0} 
//         sx={{ 
//           height: { md: 'calc(100vh - 180px)' },
//           minHeight: '650px',
//           borderRadius: '10px', 
//           backgroundColor: 'white', 
//           display: 'flex', 
//           flexDirection: 'column', 
//           overflow: 'hidden', 
//           mt: 2 
//         }}
//       >
//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: theme.spacing(4), flexGrow: 1, overflow: 'auto' }}>
//           <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: theme.spacing(3), padding: theme.spacing(3) }}>
//             <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px' }}>Select Provider</Typography>
            
//             <RadioGroup row value={selectedProvider} name="select-provider-group">
//                 <FormControlLabel 
//                     value="google-cloud-platform" 
//                     disabled
//                     control={<Radio sx={{ display: 'none', color:"#0064FF" }} />} 
//                     label={
//                         <Box sx={{ 
//                             display: 'flex', 
//                             alignItems: 'center', 
//                             gap: 1.5, 
//                             px: 1, 
//                             py: 1, 
//                             borderRadius: '8px', 
//                             border: '1px solid #0064FF',
//                             backgroundColor: '#F3F8FE',
//                             width: '255px', 
//                             height: '35px',
//                             cursor: 'not-allowed',
//                             opacity: 0.8,
//                             marginLeft:1.2
//                         }}>
//                             <img src="/icons/google-cloud-icon-2048x1646-7admxejz.svg" alt="GCP" style={{ height: 20, width: 20 }} />
//                             <Typography sx={{ flexGrow: 1, fontSize: '12px', color: '#333333' }}>Google Cloud Platform</Typography>
//                             <Box sx={{ 
//                                 ml: 'auto', 
//                                 width: 16, 
//                                 height: 16, 
//                                 borderRadius: '50%', 
//                                 border: `1px solid #0064FF`, 
//                                 display: 'flex', 
//                                 alignItems: 'center', 
//                                 justifyContent: 'center', 
//                                 flexShrink: 0, 
//                                 '&::before': { 
//                                     content: '""', 
//                                     width: 8, 
//                                     height: 8, 
//                                     borderRadius: '50%', 
//                                     backgroundColor: '#0064FF'
//                                 } 
//                             }} />
//                         </Box>
//                     }
//                 />
//             </RadioGroup>
            
//             <Divider />
//             <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px' }}>Billing Account Details</Typography>
//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 0 }}>
//                 <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 1.5 }}>
//                     <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="dataSourceName" sx={externalLabelStyle}>Data Source Name *</InputLabel><TextField autoFocus required fullWidth id="dataSourceName" name="name" size="small" placeholder="Enter your data source name" sx={sxTextField} value={name} onChange={handleInputChange} error={!!fieldErrors.name} helperText={fieldErrors.name} /></Box>
//                     <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="billingAccountId" sx={externalLabelStyle}>Billing Account ID *</InputLabel><TextField required fullWidth id="billingAccountId" name="billingAccountId" size="small" placeholder="Enter your GCP billing account ID" sx={sxTextField} value={billingAccountId} onChange={handleInputChange} error={!!fieldErrors.billingAccountId} helperText={fieldErrors.billingAccountId} /></Box>
//                 </Box>
//                 <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 1.5 }}>
//                     <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="bigQueryProjectId" sx={externalLabelStyle}>BigQuery Project ID *</InputLabel><TextField required fullWidth id="bigQueryProjectId" name="bigQueryProjectId" size="small" placeholder="Enter your BigQuery project ID" sx={sxTextField} value={bigQueryProjectId} onChange={handleInputChange} error={!!fieldErrors.bigQueryProjectId} helperText={fieldErrors.bigQueryProjectId} /></Box>
//                     <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="bigQueryDatasetId" sx={externalLabelStyle}>BigQuery Dataset ID *</InputLabel><TextField required fullWidth id="bigQueryDatasetId" name="bigQueryDatasetId" size="small" placeholder="Enter your BigQuery dataset ID" sx={sxTextField} value={bigQueryDatasetId} onChange={handleInputChange} error={!!fieldErrors.bigQueryDatasetId} helperText={fieldErrors.bigQueryDatasetId} /></Box>
//                 </Box>
//                 <Box sx={{ mt: 1.5, width:'49%' }}><InputLabel htmlFor="bigQueryDataTableName" sx={externalLabelStyle}>BigQuery Table Name *</InputLabel><TextField required fullWidth id="bigQueryDataTableName" name="bigQueryDataTableName" size="small" placeholder="Enter your BigQuery table name" sx={sxTextField} value={bigQueryDataTableName} onChange={handleInputChange} error={!!fieldErrors.bigQueryDataTableName} helperText={fieldErrors.bigQueryDataTableName} /></Box>
//             </Box>
            
//           </Box>
//           <Box sx={{ width: { xs: '100%', md: 320 }, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 2, padding: '15px', backgroundColor:'rgba(243, 248, 254, 1)'}}>
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',backgroundColor:' rgba(228, 240, 253, 1)' }}>
//               <Box sx={{ width :'250px', mr: 1 , padding:'12px'}}>
//               <Typography variant="h5" sx={{ fontSize:'12px',fontWeight: 600,mb:0.5 }}>Setup Guide</Typography>
//               <Typography variant="body2" sx={{ fontSize:'11px',fontWeight: 400 }}>Step-by-step guide to set up GCP billing data access.</Typography></Box>
//               <img src="/icons/step-guide.svg" alt="Setup Guide" style={{ height: '70px', width: '70px', flexShrink: 0 }} />              
//             </Box>
//             {stepsData.map((item, index) => (
//             <Box  sx={{ padding: '0px 10px 5px 5px',}} textAlign={'left'}  key={index}>
//               <Typography variant="caption" sx={{ fontFamily: 'Inter, sans-serif', fontSize: '10px', fontWeight: 600, color: 'primary.main', textTransform: 'uppercase' }}>
//                 {item.step}
//               </Typography>
//               <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', fontWeight: 600 }}>
//                 {item.title}
//               </Typography>
//               <Typography variant="body2" sx={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', color: 'text.secondary', whiteSpace: 'pre-line', wordBreak: 'break-all' }}>
//                 {item.description}
//               </Typography>
//             </Box>
//             ))}
//             {saError && <Alert severity="warning">Could not load service account email.</Alert>}
//           </Box>
//         </Box>        
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, p: 2, borderTop: 1, borderColor: 'divider', flexShrink: 0, mt: 'auto' }}>
//             <Button variant="text" href="https://cloud.google.com/billing/docs/how-to/find-billing-account-id" target="_blank" rel="noopener noreferrer" sx={{ color:'rgba(0, 100, 255, 1)', mr: 'auto', textTransform: 'none', textDecoration: 'none' }} startIcon={<img src="/linkurl.svg" alt="Help icon" width="16" height="16"/>}>
//                 Where do I find my Billing Account ID?
//             </Button>
//             <Button variant="outlined" sx={{ textTransform: 'none', fontFamily:'Inter', borderRadius:'8px',borderColor: 'text.primary', color:'rgba(51, 51, 51, 1)' }} onClick={() => navigate('/data-sources')}>Cancel</Button>            
//             <Button 
//                 variant="contained" 
//                 sx={{ 
//                     textTransform: 'none',
//                     fontFamily:'Inter', 
//                     borderRadius:'8px', 
//                     backgroundColor: '#0064FF',
//                     color: '#FFFFFF'
//                 }}
//                 onClick={handleSubmit} 
//                 disabled={!canSubmit || isSubmitting} 
//                 startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
//             >
//                 {isSubmitting ? (updateLoading ? 'Saving...' : 'Validating...') : 'Save Changes'}
//             </Button>
//         </Box>
//       </Paper>
//       <ErrorDialog open={isErrorDialogOpen} onClose={() => setIsErrorDialogOpen(false)} title={errorDialogContent.title} message={errorDialogContent.message} />
//     </Box>
//   );

// };

// export default EditDataSourcesPage;




// import React, { useState, useMemo, useEffect } from 'react';
// import {
//   Box, Typography, Button, TextField, RadioGroup, FormControlLabel,
//   Radio, Paper, Divider, InputLabel, CircularProgress,
//   Dialog, DialogContent, DialogActions, Snackbar, Alert,
// } from '@mui/material';
// import { useTheme, alpha } from '@mui/material/styles';
// import { Close as CloseIcon } from '@mui/icons-material';
// import { useNavigate, useParams, useOutletContext } from 'react-router-dom';
// import { gql, useMutation, useQuery, useLazyQuery } from '@apollo/client';
// import type { Tenant } from '../../App';

// export enum GQLProviderType {
//   GCP = "GCP",
//   AWS = "AWS",
//   AZURE = "Azure",
// }

// // --- Custom icon for the error toast ---
// const CustomErrorIcon = () => (
//     <Box
//       component="span"
//       sx={{
//         width: 24,
//         height: 24,
//         borderRadius: '50%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         backgroundColor: '#D92D20',
//       }}
//     >
//       <CloseIcon sx={{ color: 'white', fontSize: '16px' }} />
//     </Box>
// );

// // --- GraphQL Definitions ---
// const GET_DATA_SOURCE_FOR_EDIT = gql`
//   query GetDataSourceForEdit($dataSourceId: ID!) {
//     dataSourceById(id: $dataSourceId) {
//       id
//       name
//       providerType
//       billingAccountId
//       billingConfig
//       tenantId
//     }
//   }
// `;

// const GET_TENANT_PROVIDER_ACCESS = gql`
//   query GetTenantProviderAccess($tenantId: ID!, $providerType: ProviderType!) {
//     getTenantProviderAccess(tenantId: $tenantId, providerType: $providerType) {
//       serviceAccountEmail
//     }
//   }
// `;

// const UPDATE_DATA_SOURCE_MUTATION = gql`
//   mutation EditDataSource($id: ID!, $input: EditDataSourceInput!) {
//     editDataSource(id: $id, input: $input) {
//       id
//     }
//   }
// `;

// const VALIDATE_NEW_DATA_SOURCE_CREDENTIALS_MUTATION = gql`
//   mutation ValidateNewDataSourceCredentials($input: ValidateNewDataSourceCredentialsInput!) {
//     validateNewDataSourceCredentials(input: $input) { isValid validationErrors }
//   }
// `;
  
// // --- Interfaces ---
// interface DataSourceForEdit {
//     id: string;
//     name: string;
//     providerType: string;
//     billingAccountId: string;
//     tenantId: string;
//     billingConfig: {
//         bigQueryProjectId: string;
//         bigQueryDatasetId: string;
//         bigQueryDataTableName: string;
//     } | null;
// }

// interface EditDataSourceOutletContext {
//   currentTenant: Tenant | null;
// }

// const mapGqlToProviderValue = (gqlProvider: string): string => {
//     switch(gqlProvider) {
//         case 'GCP': return 'google-cloud-platform';
//         case 'AWS': return 'aws';
//         case 'AZURE': return 'azure';
//         default: return 'google-cloud-platform';
//     }
// };

// const mapProviderToGqlType = (frontendProviderValue: string): GQLProviderType => {
//   switch (frontendProviderValue) {
//     case 'google-cloud-platform': return GQLProviderType.GCP;
//     case 'aws': return GQLProviderType.AWS;
//     case 'azure': return GQLProviderType.AZURE;
//     default: throw new Error(`Unsupported provider value: ${frontendProviderValue}`);
//   }
// };

// const EditDataSourcesPage: React.FC = () => {
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const { dataSourceId } = useParams<{ dataSourceId: string }>();
//   const { currentTenant } = useOutletContext<EditDataSourceOutletContext>();
//   const activeTenantId = currentTenant?.id;

//   // Form State
//   const [name, setName] = useState('');
//   const [billingAccountId, setBillingAccountId] = useState('');
//   const [bigQueryProjectId, setBigQueryProjectId] = useState('');
//   const [bigQueryDatasetId, setBigQueryDatasetId] = useState('');
//   const [bigQueryDataTableName, setBigQueryDataTableName] = useState('');
//   const [selectedProvider, setSelectedProvider] = useState('google-cloud-platform');
//   const [originalTenantId, setOriginalTenantId] = useState<string | null>(null);
  
//   const [fieldErrors, setFieldErrors] = useState({
//     name: '',
//     billingAccountId: '',
//     bigQueryProjectId: '',
//     bigQueryDatasetId: '',
//     bigQueryDataTableName: '',
//   });
  
//   const [serviceAccountEmail, setServiceAccountEmail] = useState<string | null>(null);
  
//   // State for the error toast
//   const [isToastOpen, setIsToastOpen] = useState(false);
//   const [toastMessage, setToastMessage] = useState('');

//   // --- GraphQL Hooks ---
//   const { loading: queryLoading, error: queryError } = useQuery<{ dataSourceById: DataSourceForEdit }>(GET_DATA_SOURCE_FOR_EDIT, {
//     variables: { dataSourceId },
//     skip: !dataSourceId,
//     onCompleted: (data) => {
//         if (data.dataSourceById) {
//             const ds = data.dataSourceById;
//             setName(ds.name);
//             setBillingAccountId(ds.billingAccountId);
//             setSelectedProvider(mapGqlToProviderValue(ds.providerType));
//             setOriginalTenantId(ds.tenantId);
//             setBigQueryProjectId(ds.billingConfig?.bigQueryProjectId || '');
//             setBigQueryDatasetId(ds.billingConfig?.bigQueryDatasetId || '');
//             setBigQueryDataTableName(ds.billingConfig?.bigQueryDataTableName || '');
//         }
//     }
//   });

//   const [getTenantAccess, { loading: saLoading, error: saError }] = useLazyQuery(GET_TENANT_PROVIDER_ACCESS);
//   const [updateDataSource, { loading: updateLoading }] = useMutation(UPDATE_DATA_SOURCE_MUTATION);
//   const [validateCredentials, { loading: validateLoading }] = useMutation(VALIDATE_NEW_DATA_SOURCE_CREDENTIALS_MUTATION);

//   useEffect(() => {
//     if (activeTenantId && selectedProvider === 'google-cloud-platform') {
//         getTenantAccess({
//             variables: {
//                 tenantId: activeTenantId,
//                 providerType: GQLProviderType.GCP
//             },
//             onCompleted: (data) => {
//                 setServiceAccountEmail(data.getTenantProviderAccess?.serviceAccountEmail || null);
//             }
//         });
//     }
//   }, [activeTenantId, selectedProvider, getTenantAccess]);

//   const stepsData = useMemo(() => [
//     { step: 'STEP 1', title: 'Enable billing export to BigQuery', description: 'Go to Billing > Billing Export > Export to BigQuery > Choose Dataset' },
//     { 
//       step: 'STEP 2', 
//       title: 'Assign Roles to Service Account', 
//       description: serviceAccountEmail 
//         ? `Give the following roles:\n * BigQuery Data Viewer\n * BigQuery Job User\nTo: The service account (${serviceAccountEmail})`
//         : (saLoading ? 'Fetching service account details...' : 'Could not retrieve service account.') 
//     },
//     { step: 'STEP 4', title: 'Provide the following information below', description: 'Enter your GCP credentials and dataset details' },
//   ], [serviceAccountEmail, saLoading]);

//   const validateField = (name: string, value: string): string => {
//     switch (name) {
//       case 'name':
//         if (!/^[a-z0-9\s]{2,50}$/.test(value)) return 'Must be 2-50 chars, lowercase letters, numbers, spaces.';
//         break;
//       case 'billingAccountId':
//         if (!/^[0-9A-F]{6}-[0-9A-F]{6}-[0-9A-F]{6}$/i.test(value)) return 'Format: XXXXXX-XXXXXX-XXXXXX (hex digits).';
//         break;
//       case 'bigQueryProjectId':
//         if (!/^[a-z][a-z0-9-]{4,28}[a-z0-9]$/.test(value)) return '6-30 chars, starts with letter, ends with letter/num, only lowercase, nums, hyphens.';
//         break;
//       case 'bigQueryDatasetId':
//         if (!/^[a-zA-Z][a-zA-Z0-9_]{0,1023}$/.test(value)) return '1-1024 chars, starts with letter, only letters, nums, underscores.';
//         break;
//       case 'bigQueryDataTableName':
//         if (!/^[a-zA-Z_][a-zA-Z0-9_-]{0,1023}$/.test(value)) {
//           return '1-1024 chars, starts with letter or underscore, can only contain letters, nums, underscores, or hyphens.';
//         }
//         const prefixes = ['_table_', '_file_', '_partition_'];
//         if (prefixes.some(p => value.toLowerCase().startsWith(p))) {
//           return 'Cannot start with _TABLE_, _FILE_, or _PARTITION_.';
//         }
//         break;
//       default:
//         break;
//     }
//     return '';
//   };

//   const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const { name: fieldName, value } = event.target;
//     let errorMessage = '';

//     switch (fieldName) {
//       case 'name': setName(value); errorMessage = validateField(fieldName, value); break;
//       case 'billingAccountId': setBillingAccountId(value); errorMessage = validateField(fieldName, value); break;
//       case 'bigQueryProjectId': setBigQueryProjectId(value); errorMessage = validateField(fieldName, value); break;
//       case 'bigQueryDatasetId': setBigQueryDatasetId(value); errorMessage = validateField(fieldName, value); break;
//       case 'bigQueryDataTableName': setBigQueryDataTableName(value); errorMessage = validateField(fieldName, value); break;
//       default: break;
//     }
//     setFieldErrors(prev => ({ ...prev, [fieldName]: errorMessage }));
//   };
  
//   const canSubmit = useMemo(() => (
//     name.trim() !== '' && billingAccountId.trim() !== '' &&
//     bigQueryProjectId.trim() !== '' && bigQueryDatasetId.trim() !== '' && bigQueryDataTableName.trim() !== '' &&
//     Object.values(fieldErrors).every(error => error === '')
//   ), [name, billingAccountId, bigQueryProjectId, bigQueryDatasetId, bigQueryDataTableName, fieldErrors]);

//   const handleToastClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
//     if (reason === 'clickaway') return;
//     setIsToastOpen(false);
//   };

//   const handleSubmit = async () => {
//     if (!canSubmit || !dataSourceId) return;

//     const validationInput = {
//         name: name.trim(),
//         tenantId: originalTenantId,
//         providerType: mapProviderToGqlType(selectedProvider),
//         billingAccountId: billingAccountId.trim(),
//         bigQueryProjectId: bigQueryProjectId.trim(),
//         bigQueryDatasetId: bigQueryDatasetId.trim(),
//         bigQueryDataTableName: bigQueryDataTableName.trim(),
//     };

//     try {
//         const validationResponse = await validateCredentials({
//             variables: { input: validationInput },
//         });

//         const validationResult = validationResponse.data?.validateNewDataSourceCredentials;

//         if (!validationResult?.isValid) {
//             setToastMessage("We are unable to update the Data Source at this moment. Please try again after some time.");
//             setIsToastOpen(true);
//             return;
//         }

//         const updateInput = {
//             name: name.trim(),
//             billingAccountId: billingAccountId.trim(),
//             bigQueryProjectId: bigQueryProjectId.trim(),
//             bigQueryDatasetId: bigQueryDatasetId.trim(),
//             bigQueryDataTableName: bigQueryDataTableName.trim(),
//         };

//         const updateResponse = await updateDataSource({
//             variables: { id: dataSourceId, input: updateInput },
//         });

//         if (updateResponse.errors) {
//             setToastMessage("We are unable to update the Data Source at this moment. Please try again after some time.");
//             setIsToastOpen(true);
//             return;
//         }

//         navigate('/data-sources', { state: { dataSourceUpdated: true } });

//     } catch (e: any) {
//         setToastMessage("We are unable to update the Data Source at this moment. Please try again after some time.");
//         setIsToastOpen(true);
//     }
//   };

//   const externalLabelStyle = { fontFamily: 'Inter, sans-serif', fontSize: '12px', fontWeight: 400, color: theme.palette.text.primary, marginBottom: theme.spacing(0.75), display: 'block' };
//   const sxTextField = { '& .MuiOutlinedInput-root': { '& fieldset': { borderRadius: '8px' } }, '& .MuiInputBase-input': { fontFamily: 'Inter, sans-serif', color: theme.palette.text.primary, fontSize: '12px' }, '& .MuiInputBase-input::placeholder': { fontFamily: 'Inter, sans-serif', color: 'rgba(185, 185, 185, 1)', fontSize: '12px', opacity: 1 } };
//   const handleGoBack = () => navigate('/data-sources');

//   const isSubmitting = updateLoading || validateLoading;

//   if (queryLoading) return <Box sx={{display: 'flex', justifyContent: 'center', p:4}}><CircularProgress /></Box>
//   if (queryError) return <Alert severity="error">Error loading data for editing: {queryError.message}</Alert>

//   return (
//     <Box sx={{ p: { xs: 2, sm: 3 } }}>
//       <Box sx={{ mb: 2, flexShrink: 0 }}>
//         <Button
//           onClick={handleGoBack}
//           startIcon={<img src="/icons/back-arrow.svg" alt="Back" style={{ width: '12px', height: '12px' }} />}
//           sx={{ p: 0, textTransform: 'none', color: 'text.primary', '&:hover': { backgroundColor: 'transparent' } }}
//         >
//           <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px', marginLeft:'4px' }}>
//             Edit Data Source
//           </Typography>
//         </Button>
//         <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: '12px', color: 'rgba(102, 102, 102, 1)', mt: 0.5,marginRight:10, marginLeft:2 }}>
//           Update the Billing Account IDs and linked BigQuery dataset details.
//         </Typography>
//       </Box>

//       <Paper 
//         elevation={0} 
//         sx={{ 
//           height: { md: 'calc(100vh - 180px)' },
//           minHeight: '650px',
//           borderRadius: '10px', 
//           backgroundColor: 'white', 
//           display: 'flex', 
//           flexDirection: 'column', 
//           overflow: 'hidden', 
//           mt: 2 
//         }}
//       >
//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: theme.spacing(4), flexGrow: 1, overflow: 'auto' }}>
//           <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: theme.spacing(3), padding: theme.spacing(3) }}>
//             <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px' }}>Select Provider</Typography>
            
//             <RadioGroup row value={selectedProvider} name="select-provider-group">
//                 <FormControlLabel 
//                     value="google-cloud-platform" 
//                     disabled
//                     control={<Radio sx={{ display: 'none' }} />} 
//                     label={
//                         <Box sx={{ 
//                             display: 'flex', 
//                             alignItems: 'center', 
//                             gap: 1.5, 
//                             px: 1, 
//                             py: 1, 
//                             borderRadius: '8px', 
//                             border: '1px solid #0064FF',
//                             backgroundColor: '#F3F8FE',
//                             width: '255px', 
//                             height: '35px',
//                             cursor: 'not-allowed',
//                             opacity: 0.8,
//                             marginLeft:1.2
//                         }}>
//                             <img src="/icons/google-cloud-icon-2048x1646-7admxejz.svg" alt="GCP" style={{ height: 20, width: 20 }} />
//                             <Typography sx={{ flexGrow: 1, fontSize: '12px', color: '#333333' }}>Google Cloud Platform</Typography>
//                             <Box sx={{ 
//                                 ml: 'auto', 
//                                 width: 16, 
//                                 height: 16, 
//                                 borderRadius: '50%', 
//                                 border: `1px solid #0064FF`, 
//                                 display: 'flex', 
//                                 alignItems: 'center', 
//                                 justifyContent: 'center', 
//                                 flexShrink: 0, 
//                                 '&::before': { 
//                                     content: '""', 
//                                     width: 8, 
//                                     height: 8, 
//                                     borderRadius: '50%', 
//                                     backgroundColor: '#0064FF'
//                                 } 
//                             }} />
//                         </Box>
//                     }
//                 />
//             </RadioGroup>
            
//             <Divider />
//             <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px' }}>Billing Account Details</Typography>
//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 0 }}>
//                 <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 1.5 }}>
//                     <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="dataSourceName" sx={externalLabelStyle}>Data Source Name *</InputLabel><TextField autoFocus required fullWidth id="dataSourceName" name="name" size="small" placeholder="Enter your data source name" sx={sxTextField} value={name} onChange={handleInputChange} error={!!fieldErrors.name} helperText={fieldErrors.name} /></Box>
//                     <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="billingAccountId" sx={externalLabelStyle}>Billing Account ID *</InputLabel><TextField required fullWidth id="billingAccountId" name="billingAccountId" size="small" placeholder="Enter your GCP billing account ID" sx={sxTextField} value={billingAccountId} onChange={handleInputChange} error={!!fieldErrors.billingAccountId} helperText={fieldErrors.billingAccountId} /></Box>
//                 </Box>
//                 <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 1.5 }}>
//                     <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="bigQueryProjectId" sx={externalLabelStyle}>BigQuery Project ID *</InputLabel><TextField required fullWidth id="bigQueryProjectId" name="bigQueryProjectId" size="small" placeholder="Enter your BigQuery project ID" sx={sxTextField} value={bigQueryProjectId} onChange={handleInputChange} error={!!fieldErrors.bigQueryProjectId} helperText={fieldErrors.bigQueryProjectId} /></Box>
//                     <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="bigQueryDatasetId" sx={externalLabelStyle}>BigQuery Dataset ID *</InputLabel><TextField required fullWidth id="bigQueryDatasetId" name="bigQueryDatasetId" size="small" placeholder="Enter your BigQuery dataset ID" sx={sxTextField} value={bigQueryDatasetId} onChange={handleInputChange} error={!!fieldErrors.bigQueryDatasetId} helperText={fieldErrors.bigQueryDatasetId} /></Box>
//                 </Box>
//                 <Box sx={{ mt: 1.5, width:'49%' }}><InputLabel htmlFor="bigQueryDataTableName" sx={externalLabelStyle}>BigQuery Table Name *</InputLabel><TextField required fullWidth id="bigQueryDataTableName" name="bigQueryDataTableName" size="small" placeholder="Enter your BigQuery table name" sx={sxTextField} value={bigQueryDataTableName} onChange={handleInputChange} error={!!fieldErrors.bigQueryDataTableName} helperText={fieldErrors.bigQueryDataTableName} /></Box>
//             </Box>
            
//           </Box>
//           <Box sx={{ width: { xs: '100%', md: 320 }, flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 2, padding: '15px', backgroundColor:'rgba(243, 248, 254, 1)'}}>
//             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',backgroundColor:' rgba(228, 240, 253, 1)' }}>
//               <Box sx={{ width :'250px', mr: 1 , padding:'12px'}}>
//               <Typography variant="h5" sx={{ fontSize:'12px',fontWeight: 600,mb:0.5 }}>Setup Guide</Typography>
//               <Typography variant="body2" sx={{ fontSize:'11px',fontWeight: 400 }}>Step-by-step guide to set up GCP billing data access.</Typography></Box>
//               <img src="/icons/step-guide.svg" alt="Setup Guide" style={{ height: '70px', width: '70px', flexShrink: 0 }} />              
//             </Box>
//             {stepsData.map((item, index) => (
//             <Box  sx={{ padding: '0px 10px 5px 5px',}} textAlign={'left'}  key={index}>
//               <Typography variant="caption" sx={{ fontFamily: 'Inter, sans-serif', fontSize: '10px', fontWeight: 600, color: 'primary.main', textTransform: 'uppercase' }}>
//                 {item.step}
//               </Typography>
//               <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', fontWeight: 600 }}>
//                 {item.title}
//               </Typography>
//               <Typography variant="body2" sx={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', color: 'text.secondary', whiteSpace: 'pre-line', wordBreak: 'break-all' }}>
//                 {item.description}
//               </Typography>
//             </Box>
//             ))}
//             {saError && <Alert severity="warning">Could not load service account email.</Alert>}
//           </Box>
//         </Box>        
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, p: 2, borderTop: 1, borderColor: 'divider', flexShrink: 0, mt: 'auto' }}>
//             <Button variant="text" href="https://cloud.google.com/billing/docs/how-to/find-billing-account-id" target="_blank" rel="noopener noreferrer" sx={{ color:'rgba(0, 100, 255, 1)', mr: 'auto', textTransform: 'none', textDecoration: 'none' }} startIcon={<img src="/linkurl.svg" alt="Help icon" width="16" height="16"/>}>
//                 Where do I find my Billing Account ID?
//             </Button>
//             <Button variant="outlined" sx={{ textTransform: 'none', fontFamily:'Inter', borderRadius:'8px',borderColor: 'text.primary', color:'rgba(51, 51, 51, 1)' }} onClick={() => navigate('/data-sources')}>Cancel</Button>            
//             <Button 
//                 variant="contained" 
//                 sx={{ 
//                     textTransform: 'none',
//                     fontFamily:'Inter', 
//                     borderRadius:'8px', 
//                     backgroundColor: '#0064FF',
//                     color: '#FFFFFF'
//                 }}
//                 onClick={handleSubmit} 
//                 disabled={!canSubmit || isSubmitting} 
//                 startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
//             >
//                 {isSubmitting ? (updateLoading ? 'Saving...' : 'Validating...') : 'Save Changes'}
//             </Button>
//         </Box>
//       </Paper>
//       <Snackbar
//         open={isToastOpen}
//         autoHideDuration={6000}
//         onClose={handleToastClose}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert
//           icon={<CustomErrorIcon />} 
//           onClose={handleToastClose}
//           sx={{
//             width: '100%',
//             borderRadius: '50px',
//             backgroundColor: 'white',
//             boxShadow: theme.shadows[3],
//             color: 'text.secondary',
//             alignItems: 'center',
//             p: theme.spacing(0.5, 2),
//             '& .MuiAlert-message': {
//               flex: 1,
//               py: '12px'
//             },
//           }}
//         >
//           {toastMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );

// };

// export default EditDataSourcesPage;



// import React, { useState, useMemo, useEffect } from 'react';
// import {
//   Box, Typography, Button, TextField, RadioGroup, FormControlLabel,
//   Radio, Paper, Divider, InputLabel, CircularProgress, Snackbar, Alert, Link,
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import { alpha } from '@mui/material/styles';
// import { GitHub as GitHubIcon, Close as CloseIcon } from '@mui/icons-material';
// import { useNavigate, useParams, useOutletContext } from 'react-router-dom';
// import { gql, useMutation, useQuery, useLazyQuery } from '@apollo/client';
// import type { Tenant } from '../../App';
// import { Check as CheckIcon } from '@mui/icons-material';


// // --- CHANGE 1: Updated GQLProviderType enum to use LANGFUSE instead of LLM for consistency ---
// export enum GQLProviderType {
//   GCP = "GCP",
//   LANGFUSE = "LANGFUSE",
//   AWS = "AWS",
//   AZURE = "Azure",
// }

// const CustomErrorIcon = () => ( <Box component="span" sx={{ width: 24, height: 24, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#D92D20' }}> <CloseIcon sx={{ color: 'white', fontSize: '16px' }} /> </Box> );

// // --- CHANGE 2: Updated and improved the Langfuse Setup Guide for consistency with the Add page ---
// const LlmSetupGuide = () => {
//     const [activeManager, setActiveManager] = useState('npm');

//     const commands = {
//         npm: 'npm install langfuse\n\n# Node.js < 18\nnpm install langfuse-node',
//         pnpm: 'pnpm add langfuse\n\n# Node.js < 18\npnpm add langfuse-node',
//         yarn: 'yarn add langfuse\n\n# Node.js < 18\nyarn add langfuse-node',
//         bun: 'bun add langfuse\n\n# Node.js < 18\nbun add langfuse-node',
//     };

//     const Badge = ({ label, value, color, href }: { label: string, value: string, color: string, href?: string }) => (
//         <Button
//             component={href ? 'a' : 'button'}
//             href={href}
//             target="_blank"
//             rel="noopener noreferrer"
//             sx={{ p: 0, m: 0, height: '20px', textTransform: 'none', borderRadius: '4px', overflow: 'hidden', '&:hover': { ...(href && { opacity: 0.8 }) } }}>
//             <Box sx={{ bgcolor: '#555', color: 'white', px: 1, height: '100%', display: 'flex', alignItems: 'center' }}>
//                 {label === 'repo' && <GitHubIcon sx={{ fontSize: '14px', mr: 0.5 }} />}
//                 <Typography sx={{ fontSize: '10px', fontWeight: 500 }}>{label}</Typography>
//             </Box>
//             <Box sx={{ bgcolor: color, color: 'white', px: 1, height: '100%', display: 'flex', alignItems: 'center' }}>
//                 <Typography sx={{ fontSize: '10px', fontWeight: 500 }}>{value}</Typography>
//             </Box>
//         </Button>
//     );

//     const TabButton = ({ manager }: { manager: 'npm' | 'pnpm' | 'yarn' | 'bun' }) => (
//         <Button
//             onClick={() => setActiveManager(manager)}
//             sx={{ p: '2px 8px', minWidth: 'auto', color: activeManager === manager ? 'primary.main' : 'text.secondary', fontWeight: 500, fontSize: '13px', borderBottom: 2, borderColor: activeManager === manager ? 'primary.main' : 'transparent', borderRadius: 0, textTransform: 'none' }}>
//             {manager}
//         </Button>
//     );

//     return (
//         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//           <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Langfuse SDK Setup</Typography>
//           <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
//               The Langfuse SDKs are the recommended way to integrate with Langfuse.{' '}
//               <Link href="https://langfuse.com/integrations" target="_blank" rel="noopener noreferrer" sx={{ fontWeight: 500 }}>
//                 [See a full list of Integration]
//               </Link>
//           </Typography>
//           <Divider sx={{ my: 1 }} />
//           <Typography sx={{ fontSize: '12px', color: '#333333', fontWeight:600 }}>Install the Toolkit</Typography>
//           <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>Pick your language and run one of these commands in your project's terminal.</Typography>
//           <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>JS/TS</Typography>
//           <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//               <Badge label="repo" value="langfuse-js" color="#007ec6" href="https://github.com/langfuse/langfuse-js" />
//               <Badge label="npm langfuse" value="v3.38.4" color="#007ec6" />
//               <Badge label="npm langfuse-node" value="v3.38.4" color="#007ec6" />
//           </Box>
//           <Box sx={{ display: 'flex', borderBottom: 1, borderColor: 'divider' }}>
//               <TabButton manager="npm" /><TabButton manager="pnpm" /><TabButton manager="yarn" /><TabButton manager="bun" />
//           </Box>
//           <Box sx={{ bgcolor: '#f7f7f7', p: 1.5, borderRadius: '4px', fontFamily: 'monospace', whiteSpace: 'pre-wrap', fontSize: '12px', border: '1px solid #e0e0e0' }}>
//               {commands[activeManager as keyof typeof commands]}
//           </Box>
//           <Divider sx={{ my: 2 }} />
//           <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Python</Typography>
//           <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//               <Badge label="repo" value="langfuse-python" color="#007ec6" href="https://github.com/langfuse/langfuse-python" />
//               <Badge label="pypi langfuse" value="v3.2.3" color="#007ec6" />
//           </Box>
//           <Box sx={{ bgcolor: '#f7f7f7', p: 1.5, borderRadius: '4px', fontFamily: 'monospace', whiteSpace: 'pre-wrap', fontSize: '12px', border: '1px solid #e0e0e0', mt: 1 }}>
//               pip install langfuse
//           </Box>
//         </Box>
//     );
// };


// // --- GraphQL definitions for the unified API ---
// const GET_ANY_DATA_SOURCE_BY_ID = gql`
//   query GetAnyDataSourceById($dataSourceId: ID!) {
//     getAnyDataSourceById(id: $dataSourceId) {
//       __typename
//       ... on DataSource {
//         id
//         name
//         providerType
//         billingAccountId
//         billingConfig
//         tenantId
//       }
//       ... on LlmDataSource {
//         id
//         name
//         providerType
//         tenantId
//       }
//     }
//   }
// `;

// const GET_TENANT_PROVIDER_ACCESS = gql`
//   query GetTenantProviderAccess($tenantId: ID!, $providerType: ProviderType!) {
//     getTenantProviderAccess(tenantId: $tenantId, providerType: $providerType) {
//       serviceAccountEmail
//     }
//   }
// `;

// const EDIT_DATA_SOURCE_MUTATION = gql`
//   mutation EditDataSource($id: ID!, $input: EditDataSourceInput!) {
//     editDataSource(id: $id, input: $input) {
//       __typename
//       ... on DataSource { id }
//       ... on LlmDataSource { id }
//     }
//   }
// `;

// const VALIDATE_NEW_DATA_SOURCE_CREDENTIALS_MUTATION = gql`
//   mutation ValidateNewDataSourceCredentials($input: ValidateNewDataSourceCredentialsInput!) {
//     validateNewDataSourceCredentials(input: $input) { isValid validationErrors }
//   }
// `;

// // --- Type definitions for both data sources ---
// interface CloudDataSourceForEdit {
//     __typename: 'DataSource';
//     id: string;
//     name: string;
//     providerType: 'GCP';
//     billingAccountId: string;
//     tenantId: string;
//     billingConfig: { bigQueryProjectId: string; bigQueryDatasetId: string; bigQueryDataTableName: string; } | null;
// }

// // --- CHANGE 3: Updated LlmDataSource type to use LANGFUSE ---
// interface LlmDataSourceForEdit {
//     __typename: 'LlmDataSource';
//     id: string;
//     name: string;
//     providerType: 'LANGFUSE';
//     tenantId: string;
// }

// type AnyDataSourceForEdit = CloudDataSourceForEdit | LlmDataSourceForEdit;

// interface EditDataSourceOutletContext {
//   currentTenant: Tenant | null;
// }

// // --- CHANGE 4: Updated helper functions to handle LANGFUSE ---
// const mapGqlToProviderValue = (gqlProvider: string): string => {
//     switch(gqlProvider) {
//         case 'GCP': return 'google-cloud-platform';
//         case 'LANGFUSE': return 'langfuse';
//         case 'AWS': return 'aws';
//         case 'AZURE': return 'azure';
//         default: throw new Error(`Unsupported GQL provider type: ${gqlProvider}`);
//     }
// };

// const mapProviderToGqlType = (frontendProviderValue: string): GQLProviderType => {
//   switch (frontendProviderValue) {
//     case 'google-cloud-platform': return GQLProviderType.GCP;
//     case 'langfuse': return GQLProviderType.LANGFUSE;
//     case 'aws': return GQLProviderType.AWS;
//     case 'azure': return GQLProviderType.AZURE;
//     default: throw new Error(`Unsupported provider value: ${frontendProviderValue}`);
//   }
// };

// const EditDataSourcesPage: React.FC = () => {
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const { dataSourceId } = useParams<{ dataSourceId: string }>();
//   const { currentTenant } = useOutletContext<EditDataSourceOutletContext>();
//   const activeTenantId = currentTenant?.id;

//   const [name, setName] = useState('');
//   const [billingAccountId, setBillingAccountId] = useState('');
//   const [bigQueryProjectId, setBigQueryProjectId] = useState('');
//   const [bigQueryDatasetId, setBigQueryDatasetId] = useState('');
//   const [bigQueryDataTableName, setBigQueryDataTableName] = useState('');
//   const [selectedProvider, setSelectedProvider] = useState('');
//   const [originalTenantId, setOriginalTenantId] = useState<string | null>(null);
//   const [fieldErrors, setFieldErrors] = useState({ name: '', billingAccountId: '', bigQueryProjectId: '', bigQueryDatasetId: '', bigQueryDataTableName: '' });
//   const [serviceAccountEmail, setServiceAccountEmail] = useState<string | null>(null);
//   const [isToastOpen, setIsToastOpen] = useState(false);
//   const [toastMessage, setToastMessage] = useState('');

//   const { loading: queryLoading, error: queryError } = useQuery<{ getAnyDataSourceById: AnyDataSourceForEdit }>(GET_ANY_DATA_SOURCE_BY_ID, {
//     variables: { dataSourceId },
//     skip: !dataSourceId,
//     onCompleted: (data) => {
//         if (data.getAnyDataSourceById) {
//             const ds = data.getAnyDataSourceById;
//             setName(ds.name);
//             setSelectedProvider(mapGqlToProviderValue(ds.providerType));
//             setOriginalTenantId(ds.tenantId);
//             setBillingAccountId(''); setBigQueryProjectId(''); setBigQueryDatasetId(''); setBigQueryDataTableName('');
//             if (ds.__typename === 'DataSource') {
//                 setBillingAccountId(ds.billingAccountId);
//                 setBigQueryProjectId(ds.billingConfig?.bigQueryProjectId || '');
//                 setBigQueryDatasetId(ds.billingConfig?.bigQueryDatasetId || '');
//                 setBigQueryDataTableName(ds.billingConfig?.bigQueryDataTableName || '');
//             }
//         }
//     }
//   });

//   const [getTenantAccess, { loading: saLoading, error: saError }] = useLazyQuery(GET_TENANT_PROVIDER_ACCESS);
//   const [updateDataSource, { loading: updateLoading }] = useMutation(EDIT_DATA_SOURCE_MUTATION);
//   const [validateCredentials, { loading: validateLoading }] = useMutation(VALIDATE_NEW_DATA_SOURCE_CREDENTIALS_MUTATION);

//   useEffect(() => {
//     if (activeTenantId && selectedProvider === 'google-cloud-platform') {
//         getTenantAccess({
//             variables: { tenantId: activeTenantId, providerType: GQLProviderType.GCP },
//             onCompleted: (data) => { setServiceAccountEmail(data.getTenantProviderAccess?.serviceAccountEmail || null); }
//         });
//     }
//   }, [activeTenantId, selectedProvider, getTenantAccess]);

//   const stepsData = useMemo(() => [
//     { step: 'STEP 1', title: 'Enable billing export to BigQuery', description: 'Go to Billing > Billing Export > Export to BigQuery > Choose Dataset' },
//     { step: 'STEP 2', title: 'Assign Roles to Service Account', description: serviceAccountEmail ? `Give the following roles:\n * BigQuery Data Viewer\n * BigQuery Job User\nTo: The service account (${serviceAccountEmail})` : (saLoading ? 'Fetching service account details...' : 'Could not retrieve service account.') },
//     { step: 'STEP 3', title: 'Provide the following information below', description: 'Enter your GCP credentials and dataset details' },
//   ], [serviceAccountEmail, saLoading]);

//   // --- CHANGE 5: Updated validation logic to check for 'langfuse' ---
//   const validateField = (name: string, value: string): string => {
//     if (selectedProvider === 'langfuse' && name !== 'name') return '';
//     switch (name) {
//       case 'name': if (!/^[a-z0-9\s]{2,50}$/.test(value)) return 'Must be 2-50 chars, lowercase letters, numbers, spaces.'; break;
//       case 'billingAccountId': if (!/^[0-9A-F]{6}-[0-9A-F]{6}-[0-9A-F]{6}$/i.test(value)) return 'Format: XXXXXX-XXXXXX-XXXXXX (hex digits).'; break;
//       case 'bigQueryProjectId': if (!/^[a-z][a-z0-9-]{4,28}[a-z0-9]$/.test(value)) return '6-30 chars, starts with letter, ends with letter/num, only lowercase, nums, hyphens.'; break;
//       case 'bigQueryDatasetId': if (!/^[a-zA-Z][a-zA-Z0-9_]{0,1023}$/.test(value)) return '1-1024 chars, starts with letter, only letters, nums, underscores.'; break;
//       case 'bigQueryDataTableName': if (!/^[a-zA-Z_][a-zA-Z0-9_-]{0,1023}$/.test(value)) { return '1-1024 chars, starts with letter or underscore, can only contain letters, nums, underscores, or hyphens.'; } if (['_table_', '_file_', '_partition_'].some(p => value.toLowerCase().startsWith(p))) { return 'Cannot start with _TABLE_, _FILE_, or _PARTITION_.'; } break;
//       default: break;
//     }
//     return '';
//   };

//   const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const { name: fieldName, value } = event.target;
//     let errorMessage = '';
//     switch (fieldName) {
//       case 'name': setName(value); errorMessage = validateField(fieldName, value); break;
//       case 'billingAccountId': setBillingAccountId(value); errorMessage = validateField(fieldName, value); break;
//       case 'bigQueryProjectId': setBigQueryProjectId(value); errorMessage = validateField(fieldName, value); break;
//       case 'bigQueryDatasetId': setBigQueryDatasetId(value); errorMessage = validateField(fieldName, value); break;
//       case 'bigQueryDataTableName': setBigQueryDataTableName(value); errorMessage = validateField(fieldName, value); break;
//       default: break;
//     }
//     setFieldErrors(prev => ({ ...prev, [fieldName]: errorMessage }));
//   };

//   // --- CHANGE 6: Updated submission logic to check for 'langfuse' ---
//   const canSubmit = useMemo(() => {
//       const hasNoErrors = Object.values(fieldErrors).every(error => error === '');
//       const baseChecks = name.trim() !== '' && hasNoErrors;
//       if (selectedProvider === 'langfuse') { return baseChecks; }
//       if (selectedProvider === 'google-cloud-platform') { return baseChecks && billingAccountId.trim() !== '' && bigQueryProjectId.trim() !== '' && bigQueryDatasetId.trim() !== '' && bigQueryDataTableName.trim() !== ''; }
//       return false;
//   }, [name, billingAccountId, bigQueryProjectId, bigQueryDatasetId, bigQueryDataTableName, fieldErrors, selectedProvider]);

//   const handleToastClose = (event?: React.SyntheticEvent | Event, reason?: string) => { if (reason === 'clickaway') return; setIsToastOpen(false); };

//   const handleSubmit = async () => {
//     if (!canSubmit || !dataSourceId) return;
//     let input: any = { name: name.trim(), providerType: mapProviderToGqlType(selectedProvider) };
//     if (selectedProvider === 'google-cloud-platform') {
//         input = { ...input, billingAccountId: billingAccountId.trim(), bigQueryProjectId: bigQueryProjectId.trim(), bigQueryDatasetId: bigQueryDatasetId.trim(), bigQueryDataTableName: bigQueryDataTableName.trim() };
//         try {
//             const validationResponse = await validateCredentials({ variables: { input: { ...input, tenantId: originalTenantId } } });
//             if (!validationResponse.data?.validateNewDataSourceCredentials?.isValid) {
//                 setToastMessage("We are unable to validate the updated GCP credentials. Please check them and try again.");
//                 setIsToastOpen(true);
//                 return;
//             }
//         } catch (e) {
//             setToastMessage("An error occurred during validation. Please try again.");
//             setIsToastOpen(true);
//             return;
//         }
//     }
//     try {
//         const updateResponse = await updateDataSource({ variables: { id: dataSourceId, input } });
//         if (updateResponse.errors) { throw new Error(updateResponse.errors[0].message); }
//         navigate('/data-sources', { state: { dataSourceUpdated: true } });
//     } catch (e: any) {
//         setToastMessage("We were unable to save the changes. Please try again later.");
//         setIsToastOpen(true);
//     }
//   };

//   const externalLabelStyle = { fontFamily: 'Inter, sans-serif', fontSize: '12px', fontWeight: 400, color: theme.palette.text.primary, marginBottom: theme.spacing(0.75), display: 'block' };
//   const sxTextField = { '& .MuiOutlinedInput-root': { '& fieldset': { borderRadius: '8px' }, '&.Mui-focused fieldset': { borderColor: 'rgba(0, 0, 0, 0.23)' },},'& .MuiInputBase-input': { fontFamily: 'Inter, sans-serif', color: theme.palette.text.primary, fontSize: '12px' }, '& .MuiInputBase-input::placeholder': { fontFamily: 'Inter, sans-serif', color: 'rgba(185, 185, 185, 1)', fontSize: '12px', opacity: 1 } };
//   const handleGoBack = () => navigate('/data-sources');

//   const isSubmitting = updateLoading || validateLoading;

//   if (queryLoading) return <Box sx={{display: 'flex', justifyContent: 'center', p:4}}><CircularProgress /></Box>;
//   if (queryError) return <Alert severity="error">Error loading data for editing: {queryError.message}</Alert>;

//   return (
//     <Box sx={{ p: { xs: 2, sm: 3 } }}>
//       <Box sx={{ mb: 2, flexShrink: 0 }}>
//         <Button onClick={handleGoBack} startIcon={<img src="/icons/back-arrow.svg" alt="Back" style={{ width: '12px', height: '12px' }} />} sx={{ p: 0, textTransform: 'none', color: 'text.primary', '&:hover': { backgroundColor: 'transparent' } }}>
//           <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px', marginLeft:'4px' }}>Edit Data Source</Typography>
//         </Button>
//         <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: '12px', color: 'rgba(102, 102, 102, 1)', mt: 0.5,marginRight:10, marginLeft:2 }}>Update your data source details.</Typography>
//       </Box>

//       <Paper elevation={0} sx={{ height: { md: 'calc(100vh - 180px)' }, minHeight: '650px', borderRadius: '10px', backgroundColor: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden', mt: 2 }}>
//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: theme.spacing(4), flexGrow: 1, overflow: 'auto' }}>
//           <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: theme.spacing(3), padding: theme.spacing(3) }}>
//             <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px' }}>Provider</Typography>
//             <RadioGroup row value={selectedProvider} name="select-provider-group">
//                 {/* --- CHANGE 7: Conditionally render the correct, disabled provider based on 'selectedProvider' state --- */}
//                 {selectedProvider === 'google-cloud-platform' && <FormControlLabel value="google-cloud-platform" disabled control={<Radio sx={{ display: 'none' }} />} label={ <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 1, py: 1, borderRadius: '8px', border: '1px solid #0064FF', backgroundColor: '#F3F8FE', width: '255px', height: '35px', cursor: 'not-allowed', opacity: 0.8, marginLeft:1.2 }}> <img src="/icons/google-cloud-icon-2048x1646-7admxejz.svg" alt="GCP" style={{ height: 20, width: 20 }} /> <Typography sx={{ flexGrow: 1, fontSize: '12px', color: '#333333' }}>Google Cloud Platform</Typography> <Box sx={{ ml: 'auto', width: 16, height: 16, borderRadius: '50%', border: `1px solid #0064FF`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, '&::before': { content: '""', width: 8, height: 8, borderRadius: '50%', backgroundColor: '#0064FF' } }} /> </Box> } />}
//                 {selectedProvider === 'langfuse' && <FormControlLabel value="langfuse" disabled control={<Radio sx={{ display: 'none' }} />} label={ <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 1, py: 1, borderRadius: '8px', border: `1px solid #0064FF`, backgroundColor: alpha(theme.palette.primary.main, 0.05), width: '255px', height: '35px', cursor: 'not-allowed', opacity: 0.8, marginLeft:1.2 }}> <img src="/icons/llm-observability-blue.svg" alt="Langfuse" style={{ height: 18, width: 18}} /> <Typography sx={{ flexGrow: 1, fontSize: '12px' }}>Langfuse</Typography> <Box sx={{ ml: 'auto', width: 16, height: 16, borderRadius: '50%', border: `1px solid #0064FF`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, '&::before': { content: '""', width: 8, height: 8, borderRadius: '50%', backgroundColor: '#0064FF' } }} /> </Box> } />}
//             </RadioGroup>
//             <Divider />
//             {/* --- CHANGE 8: Conditionally render the section title --- */}
//             <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px', color:' #333333' }}> {selectedProvider === 'langfuse' ? 'Langfuse Details' : 'Billing Account Details'} </Typography>
            
//             {selectedProvider === 'google-cloud-platform' && (
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 0 }}>
//                     <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 1.5 }}>
//                         <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="dataSourceName" sx={externalLabelStyle}>Data Source Name *</InputLabel><TextField autoFocus required fullWidth id="dataSourceName" name="name" size="small" placeholder="Enter your data source name" sx={sxTextField} value={name} onChange={handleInputChange} error={!!fieldErrors.name} helperText={fieldErrors.name} InputProps={{ endAdornment: name && !fieldErrors.name && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}} /></Box>
//                         <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="billingAccountId" sx={externalLabelStyle}>Billing Account ID *</InputLabel><TextField required fullWidth id="billingAccountId" name="billingAccountId" size="small" placeholder="Enter your GCP billing account ID" sx={sxTextField} value={billingAccountId} onChange={handleInputChange} error={!!fieldErrors.billingAccountId} helperText={fieldErrors.billingAccountId} InputProps={{ endAdornment: billingAccountId && !fieldErrors.billingAccountId && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}} /></Box>
//                     </Box>
//                     <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 1.5 }}>
//                         <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="bigQueryProjectId" sx={externalLabelStyle}>BigQuery Project ID *</InputLabel><TextField required fullWidth id="bigQueryProjectId" name="bigQueryProjectId" size="small" placeholder="Enter your BigQuery project ID" sx={sxTextField} value={bigQueryProjectId} onChange={handleInputChange} error={!!fieldErrors.bigQueryProjectId} helperText={fieldErrors.bigQueryProjectId} InputProps={{ endAdornment: bigQueryProjectId && !fieldErrors.bigQueryProjectId && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}} /></Box>
//                         <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="bigQueryDatasetId" sx={externalLabelStyle}>BigQuery Dataset ID *</InputLabel><TextField required fullWidth id="bigQueryDatasetId" name="bigQueryDatasetId" size="small" placeholder="Enter your BigQuery dataset ID" sx={sxTextField} value={bigQueryDatasetId} onChange={handleInputChange} error={!!fieldErrors.bigQueryDatasetId} helperText={fieldErrors.bigQueryDatasetId} InputProps={{ endAdornment: bigQueryDatasetId && !fieldErrors.bigQueryDatasetId && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}}/></Box>
//                     </Box>
//                     <Box sx={{ mt: 1.5, width:'49%' }}><InputLabel htmlFor="bigQueryDataTableName" sx={externalLabelStyle}>BigQuery Table Name *</InputLabel><TextField required fullWidth id="bigQueryDataTableName" name="bigQueryDataTableName" size="small" placeholder="Enter your BigQuery table name" sx={sxTextField} value={bigQueryDataTableName} onChange={handleInputChange} error={!!fieldErrors.bigQueryDataTableName} helperText={fieldErrors.bigQueryDataTableName} InputProps={{ endAdornment: bigQueryDataTableName && !fieldErrors.bigQueryDataTableName && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}}/></Box>
//                 </Box>
//             )}
//             {/* --- CHANGE 9: Conditionally render form fields for Langfuse --- */}
//             {selectedProvider === 'langfuse' && (
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 0 }}>
//                     <Box sx={{ mt: 1.5, width: { xs: '100%', sm: 'calc(50% - 8px)' } }}>
//                         <InputLabel htmlFor="dataSourceName" sx={externalLabelStyle}>Data Source Name *</InputLabel>
//                         <TextField autoFocus required fullWidth id="dataSourceName" name="name" size="small" placeholder="Enter your data source name" sx={sxTextField} value={name} onChange={handleInputChange} error={!!fieldErrors.name} helperText={fieldErrors.name} InputProps={{ endAdornment: name && !fieldErrors.name && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}} />
//                     </Box>
//                 </Box>
//             )}
//           </Box>
//           <Box sx={{ width: { xs: '100%', md: 320 }, flexShrink: 0, display: 'flex', flexDirection: 'column', backgroundColor:'rgba(243, 248, 254, 1)'}}>
//               <Box sx={{ p: '15px', pb: 0, flexShrink: 0 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',backgroundColor:'rgba(228, 240, 253, 1)', p: '12px', borderRadius: '4px' }}>
//                     <Box sx={{ width :'250px', mr: 1 }}>
//                         <Typography variant="h5" sx={{ fontSize:'12px',fontWeight: 600,mb:0.5 }}>Setup Guide</Typography>
//                         <Typography variant="body2" sx={{ fontSize:'11px',fontWeight: 400 }}>Step-by-step guide to set up data access.</Typography>
//                     </Box>
//                     <img src="/icons/step-guide.svg" alt="Setup Guide" style={{ height: '70px', width: '70px', flexShrink: 0 }} />
//                 </Box>
//               </Box>
//             <Box sx={{ flexGrow: 1, overflowY: 'auto', p: '15px', pt: 2 }}>
//                 {/* --- CHANGE 10: Conditionally render the correct setup guide --- */}
//                 {selectedProvider === 'google-cloud-platform' && (
//                   <>
//                       {saLoading && <CircularProgress size={20} sx={{alignSelf: 'center'}} />}
//                       {stepsData.map((item) => (
//                           <Box sx={{ mb: 2 }} textAlign={'left'} key={item.step}>
//                               <Typography variant="caption" sx={{ fontWeight: 600, color: 'primary.main', textTransform: 'uppercase' }}>{item.step}</Typography>
//                               <Typography sx={{ fontSize: '12px', fontWeight: 600, whiteSpace: 'pre-line' }}>{item.title}</Typography>
//                               <Typography variant="body2" sx={{ fontSize: '11px', color: 'text.secondary', whiteSpace: 'pre-line', wordBreak: 'break-word' }}>{item.description}</Typography>
//                           </Box>
//                       ))}
//                       {saError && <Alert severity="error">Failed to get Service Account Email: {saError.message}</Alert>}
//                   </>
//                 )}
//                 {selectedProvider === 'langfuse' && <LlmSetupGuide />}
//             </Box>
//           </Box>
//         </Box>
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, p: 2, borderTop: 1, borderColor: 'divider', flexShrink: 0, mt: 'auto' }}>
//             <Button variant="text" href="https://cloud.google.com/billing/docs/how-to/find-billing-account-id" target="_blank" rel="noopener noreferrer" sx={{ color:'rgba(0, 100, 255, 1)', mr: 'auto', textTransform: 'none', textDecoration: 'none' }} startIcon={<img src="/linkurl.svg" alt="Help icon" width="16" height="16"/>}>Where do I find my Billing Account ID?</Button>
//             <Button sx={{ backgroundColor:' #F2F7FF',textTransform: 'none', fontFamily:'Inter', borderRadius:'8px',borderColor: '#0064FF', color:'#0064FF'}} onClick={() => navigate('/data-sources')}>Cancel</Button>
//             <Button variant="contained" sx={{ textTransform: 'none', fontFamily:'Inter', borderRadius:'8px', backgroundColor: '#0064FF', color: '#FFFFFF' }} onClick={handleSubmit} disabled={!canSubmit || isSubmitting} startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}>
//                 {isSubmitting ? (updateLoading ? 'Saving...' : 'Validating...') : 'Save Changes'}
//             </Button>
//         </Box>
//       </Paper>
//       <Snackbar open={isToastOpen} autoHideDuration={6000} onClose={handleToastClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
//         <Alert icon={<CustomErrorIcon />} onClose={handleToastClose} sx={{ width: '100%', borderRadius: '50px', backgroundColor: 'white', boxShadow: theme.shadows[3], color: 'text.secondary', alignItems: 'center', p: theme.spacing(0.5, 2), '& .MuiAlert-message': { flex: 1, py: '12px' } }}>
//           {toastMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default EditDataSourcesPage;


import React, { useState, useMemo, useEffect } from 'react';
import {
  Box, Typography, Button, TextField, RadioGroup, FormControlLabel,
  Radio, Paper, Divider, InputLabel, CircularProgress, Snackbar, Alert, Link,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { GitHub as GitHubIcon, Close as CloseIcon } from '@mui/icons-material';
import { useNavigate, useParams, useOutletContext } from 'react-router-dom';
import { gql, useMutation, useQuery, useLazyQuery } from '@apollo/client';
import type { Tenant } from '../../App';
import { Check as CheckIcon } from '@mui/icons-material';


// --- GQLProviderType enum using LLM for consistency ---
export enum GQLProviderType {
  GCP = "GCP",
  LANGFUSE = "LANGFUSE",
  AWS = "AWS",
  AZURE = "Azure",
}

const CustomErrorIcon = () => ( <Box component="span" sx={{ width: 24, height: 24, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#D92D20' }}> <CloseIcon sx={{ color: 'white', fontSize: '16px' }} /> </Box> );

// --- LLM Setup Guide Component ---
const LlmSetupGuide = () => {
    const [activeManager, setActiveManager] = useState('npm');

    const commands = {
        npm: 'npm install langfuse\n\n# Node.js < 18\nnpm install langfuse-node',
        pnpm: 'pnpm add langfuse\n\n# Node.js < 18\npnpm add langfuse-node',
        yarn: 'yarn add langfuse\n\n# Node.js < 18\nyarn add langfuse-node',
        bun: 'bun add langfuse\n\n# Node.js < 18\nbun add langfuse-node',
    };

    const Badge = ({ label, value, color, href }: { label: string, value: string, color: string, href?: string }) => (
        <Button
            component={href ? 'a' : 'button'}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ p: 0, m: 0, height: '20px', textTransform: 'none', borderRadius: '4px', overflow: 'hidden', '&:hover': { ...(href && { opacity: 0.8 }) } }}>
            <Box sx={{ bgcolor: '#555', color: 'white', px: 1, height: '100%', display: 'flex', alignItems: 'center' }}>
                {label === 'repo' && <GitHubIcon sx={{ fontSize: '14px', mr: 0.5 }} />}
                <Typography sx={{ fontSize: '10px', fontWeight: 500 }}>{label}</Typography>
            </Box>
            <Box sx={{ bgcolor: color, color: 'white', px: 1, height: '100%', display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '10px', fontWeight: 500 }}>{value}</Typography>
            </Box>
        </Button>
    );

    const TabButton = ({ manager }: { manager: 'npm' | 'pnpm' | 'yarn' | 'bun' }) => (
        <Button
            onClick={() => setActiveManager(manager)}
            sx={{ p: '2px 8px', minWidth: 'auto', color: activeManager === manager ? 'primary.main' : 'text.secondary', fontWeight: 500, fontSize: '13px', borderBottom: 2, borderColor: activeManager === manager ? 'primary.main' : 'transparent', borderRadius: 0, textTransform: 'none' }}>
            {manager}
        </Button>
    );

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>LLM SDK Setup</Typography>
          <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
              The Langfuse SDKs are the recommended way to integrate for LLM observability.{' '}
              <Link href="https://langfuse.com/integrations" target="_blank" rel="noopener noreferrer" sx={{ fontWeight: 500 }}>
                [See a full list of Integrations]
              </Link>
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Typography sx={{ fontSize: '12px', color: '#333333', fontWeight:600 }}>Install the Toolkit</Typography>
          <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>Pick your language and run one of these commands in your project's terminal.</Typography>
          <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>JS/TS</Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              <Badge label="repo" value="langfuse-js" color="#007ec6" href="https://github.com/langfuse/langfuse-js" />
              <Badge label="npm langfuse" value="v3.38.4" color="#007ec6" />
              <Badge label="npm langfuse-node" value="v3.38.4" color="#007ec6" />
          </Box>
          <Box sx={{ display: 'flex', borderBottom: 1, borderColor: 'divider' }}>
              <TabButton manager="npm" /><TabButton manager="pnpm" /><TabButton manager="yarn" /><TabButton manager="bun" />
          </Box>
          <Box sx={{ bgcolor: '#f7f7f7', p: 1.5, borderRadius: '4px', fontFamily: 'monospace', whiteSpace: 'pre-wrap', fontSize: '12px', border: '1px solid #e0e0e0' }}>
              {commands[activeManager as keyof typeof commands]}
          </Box>
          <Divider sx={{ my: 2 }} />
          <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Python</Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              <Badge label="repo" value="langfuse-python" color="#007ec6" href="https://github.com/langfuse/langfuse-python" />
              <Badge label="pypi langfuse" value="v3.2.3" color="#007ec6" />
          </Box>
          <Box sx={{ bgcolor: '#f7f7f7', p: 1.5, borderRadius: '4px', fontFamily: 'monospace', whiteSpace: 'pre-wrap', fontSize: '12px', border: '1px solid #e0e0e0', mt: 1 }}>
              pip install langfuse
          </Box>
        </Box>
    );
};


// --- GraphQL definitions for the unified API ---
const GET_ANY_DATA_SOURCE_BY_ID = gql`
  query GetAnyDataSourceById($dataSourceId: ID!) {
    getAnyDataSourceById(id: $dataSourceId) {
      __typename
      ... on DataSource {
        id
        name
        providerType
        billingAccountId
        billingConfig
        tenantId
      }
      ... on LlmDataSource {
        id
        name
        providerType
        tenantId
      }
    }
  }
`;

const GET_TENANT_PROVIDER_ACCESS = gql`
  query GetTenantProviderAccess($tenantId: ID!, $providerType: ProviderType!) {
    getTenantProviderAccess(tenantId: $tenantId, providerType: $providerType) {
      serviceAccountEmail
    }
  }
`;

const EDIT_DATA_SOURCE_MUTATION = gql`
  mutation EditDataSource($id: ID!, $input: EditDataSourceInput!) {
    editDataSource(id: $id, input: $input) {
      __typename
      ... on DataSource { id }
      ... on LlmDataSource { id }
    }
  }
`;

const VALIDATE_NEW_DATA_SOURCE_CREDENTIALS_MUTATION = gql`
  mutation ValidateNewDataSourceCredentials($input: ValidateNewDataSourceCredentialsInput!) {
    validateNewDataSourceCredentials(input: $input) { isValid validationErrors }
  }
`;

// --- Type definitions for both data sources ---
interface CloudDataSourceForEdit {
    __typename: 'DataSource';
    id: string;
    name: string;
    providerType: 'GCP';
    billingAccountId: string;
    tenantId: string;
    billingConfig: { bigQueryProjectId: string; bigQueryDatasetId: string; bigQueryDataTableName: string; } | null;
}

interface LlmDataSourceForEdit {
    __typename: 'LlmDataSource';
    id: string;
    name: string;
    providerType: 'LANGFUSE'; // Allow both types for safety
    tenantId: string;
}

type AnyDataSourceForEdit = CloudDataSourceForEdit | LlmDataSourceForEdit;

interface EditDataSourceOutletContext {
  currentTenant: Tenant | null;
}

// --- FIX: Updated the mapping function to handle 'LANGFUSE' from the backend ---
const mapGqlToProviderValue = (gqlProvider: string): string => {
    switch(gqlProvider) {
        case 'GCP': return 'google-cloud-platform';
        case 'LLM': return 'llm';
        case 'LANGFUSE': return 'llm'; // Maps the backend's 'LANGFUSE' to the UI's 'llm' state
        case 'AWS': return 'aws';
        case 'AZURE': return 'azure';
        default: throw new Error(`Unsupported GQL provider type: ${gqlProvider}`);
    }
};

const mapProviderToGqlType = (frontendProviderValue: string): GQLProviderType => {
  switch (frontendProviderValue) {
    case 'google-cloud-platform': return GQLProviderType.GCP;
    case 'llm': return GQLProviderType.LANGFUSE;
    case 'aws': return GQLProviderType.AWS;
    case 'azure': return GQLProviderType.AZURE;
    default: throw new Error(`Unsupported provider value: ${frontendProviderValue}`);
  }
};

const EditDataSourcesPage: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { dataSourceId } = useParams<{ dataSourceId: string }>();
  const { currentTenant } = useOutletContext<EditDataSourceOutletContext>();
  const activeTenantId = currentTenant?.id;

  const [name, setName] = useState('');
  const [billingAccountId, setBillingAccountId] = useState('');
  const [bigQueryProjectId, setBigQueryProjectId] = useState('');
  const [bigQueryDatasetId, setBigQueryDatasetId] = useState('');
  const [bigQueryDataTableName, setBigQueryDataTableName] = useState('');
  const [selectedProvider, setSelectedProvider] = useState('');
  const [originalTenantId, setOriginalTenantId] = useState<string | null>(null);
  const [fieldErrors, setFieldErrors] = useState({ name: '', billingAccountId: '', bigQueryProjectId: '', bigQueryDatasetId: '', bigQueryDataTableName: '' });
  const [serviceAccountEmail, setServiceAccountEmail] = useState<string | null>(null);
  const [isToastOpen, setIsToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const { loading: queryLoading, error: queryError } = useQuery<{ getAnyDataSourceById: AnyDataSourceForEdit }>(GET_ANY_DATA_SOURCE_BY_ID, {
    variables: { dataSourceId },
    skip: !dataSourceId,
    onCompleted: (data) => {
        if (data.getAnyDataSourceById) {
            const ds = data.getAnyDataSourceById;
            setName(ds.name);
            setSelectedProvider(mapGqlToProviderValue(ds.providerType));
            setOriginalTenantId(ds.tenantId);
            setBillingAccountId(''); setBigQueryProjectId(''); setBigQueryDatasetId(''); setBigQueryDataTableName('');
            if (ds.__typename === 'DataSource') {
                setBillingAccountId(ds.billingAccountId);
                setBigQueryProjectId(ds.billingConfig?.bigQueryProjectId || '');
                setBigQueryDatasetId(ds.billingConfig?.bigQueryDatasetId || '');
                setBigQueryDataTableName(ds.billingConfig?.bigQueryDataTableName || '');
            }
        }
    }
  });

  const [getTenantAccess, { loading: saLoading, error: saError }] = useLazyQuery(GET_TENANT_PROVIDER_ACCESS);
  const [updateDataSource, { loading: updateLoading }] = useMutation(EDIT_DATA_SOURCE_MUTATION);
  const [validateCredentials, { loading: validateLoading }] = useMutation(VALIDATE_NEW_DATA_SOURCE_CREDENTIALS_MUTATION);

  useEffect(() => {
    if (activeTenantId && selectedProvider === 'google-cloud-platform') {
        getTenantAccess({
            variables: { tenantId: activeTenantId, providerType: GQLProviderType.GCP },
            onCompleted: (data) => { setServiceAccountEmail(data.getTenantProviderAccess?.serviceAccountEmail || null); }
        });
    }
  }, [activeTenantId, selectedProvider, getTenantAccess]);

  const stepsData = useMemo(() => [
    { step: 'STEP 1', title: 'Enable billing export to BigQuery', description: 'Go to Billing > Billing Export > Export to BigQuery > Choose Dataset' },
    { step: 'STEP 2', title: 'Assign Roles to Service Account', description: serviceAccountEmail ? `Give the following roles:\n * BigQuery Data Viewer\n * BigQuery Job User\nTo: The service account (${serviceAccountEmail})` : (saLoading ? 'Fetching service account details...' : 'Could not retrieve service account.') },
    { step: 'STEP 3', title: 'Provide the following information below', description: 'Enter your GCP credentials and dataset details' },
  ], [serviceAccountEmail, saLoading]);

  const validateField = (name: string, value: string): string => {
    if (selectedProvider === 'llm' && name !== 'name') return '';
    switch (name) {
      case 'name': if (!/^[a-z0-9\s]{2,50}$/.test(value)) return 'Must be 2-50 chars, lowercase letters, numbers, spaces.'; break;
      case 'billingAccountId': if (!/^[0-9A-F]{6}-[0-9A-F]{6}-[0-9A-F]{6}$/i.test(value)) return 'Format: XXXXXX-XXXXXX-XXXXXX (hex digits).'; break;
      case 'bigQueryProjectId': if (!/^[a-z][a-z0-9-]{4,28}[a-z0-9]$/.test(value)) return '6-30 chars, starts with letter, ends with letter/num, only lowercase, nums, hyphens.'; break;
      case 'bigQueryDatasetId': if (!/^[a-zA-Z][a-zA-Z0-9_]{0,1023}$/.test(value)) return '1-1024 chars, starts with letter, only letters, nums, underscores.'; break;
      case 'bigQueryDataTableName': if (!/^[a-zA-Z_][a-zA-Z0-9_-]{0,1023}$/.test(value)) { return '1-1024 chars, starts with letter or underscore, can only contain letters, nums, underscores, or hyphens.'; } if (['_table_', '_file_', '_partition_'].some(p => value.toLowerCase().startsWith(p))) { return 'Cannot start with _TABLE_, _FILE_, or _PARTITION_.'; } break;
      default: break;
    }
    return '';
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name: fieldName, value } = event.target;
    let errorMessage = '';
    switch (fieldName) {
      case 'name': setName(value); errorMessage = validateField(fieldName, value); break;
      case 'billingAccountId': setBillingAccountId(value); errorMessage = validateField(fieldName, value); break;
      case 'bigQueryProjectId': setBigQueryProjectId(value); errorMessage = validateField(fieldName, value); break;
      case 'bigQueryDatasetId': setBigQueryDatasetId(value); errorMessage = validateField(fieldName, value); break;
      case 'bigQueryDataTableName': setBigQueryDataTableName(value); errorMessage = validateField(fieldName, value); break;
      default: break;
    }
    setFieldErrors(prev => ({ ...prev, [fieldName]: errorMessage }));
  };

  const canSubmit = useMemo(() => {
      const hasNoErrors = Object.values(fieldErrors).every(error => error === '');
      const baseChecks = name.trim() !== '' && hasNoErrors;
      if (selectedProvider === 'llm') { return baseChecks; }
      if (selectedProvider === 'google-cloud-platform') { return baseChecks && billingAccountId.trim() !== '' && bigQueryProjectId.trim() !== '' && bigQueryDatasetId.trim() !== '' && bigQueryDataTableName.trim() !== ''; }
      return false;
  }, [name, billingAccountId, bigQueryProjectId, bigQueryDatasetId, bigQueryDataTableName, fieldErrors, selectedProvider]);

  const handleToastClose = (event?: React.SyntheticEvent | Event, reason?: string) => { if (reason === 'clickaway') return; setIsToastOpen(false); };

  const handleSubmit = async () => {
    if (!canSubmit || !dataSourceId) return;
    let input: any = { name: name.trim(), providerType: mapProviderToGqlType(selectedProvider) };
    if (selectedProvider === 'google-cloud-platform') {
        input = { ...input, billingAccountId: billingAccountId.trim(), bigQueryProjectId: bigQueryProjectId.trim(), bigQueryDatasetId: bigQueryDatasetId.trim(), bigQueryDataTableName: bigQueryDataTableName.trim() };
        try {
            const validationResponse = await validateCredentials({ variables: { input: { ...input, tenantId: originalTenantId } } });
            if (!validationResponse.data?.validateNewDataSourceCredentials?.isValid) {
                setToastMessage("We are unable to validate the updated GCP credentials. Please check them and try again.");
                setIsToastOpen(true);
                return;
            }
        } catch (e) {
            setToastMessage("An error occurred during validation. Please try again.");
            setIsToastOpen(true);
            return;
        }
    }
    try {
        const updateResponse = await updateDataSource({ variables: { id: dataSourceId, input } });
        if (updateResponse.errors) { throw new Error(updateResponse.errors[0].message); }
        navigate('/data-sources', { state: { dataSourceUpdated: true } });
    } catch (e: any) {
        setToastMessage("We were unable to save the changes. Please try again later.");
        setIsToastOpen(true);
    }
  };

  const externalLabelStyle = { fontFamily: 'Inter, sans-serif', fontSize: '12px', fontWeight: 400, color: theme.palette.text.primary, marginBottom: theme.spacing(0.75), display: 'block' };
  const sxTextField = { '& .MuiOutlinedInput-root': { '& fieldset': { borderRadius: '8px' }, '&.Mui-focused fieldset': { borderColor: 'rgba(0, 0, 0, 0.23)' },},'& .MuiInputBase-input': { fontFamily: 'Inter, sans-serif', color: theme.palette.text.primary, fontSize: '12px' }, '& .MuiInputBase-input::placeholder': { fontFamily: 'Inter, sans-serif', color: 'rgba(185, 185, 185, 1)', fontSize: '12px', opacity: 1 } };
  const handleGoBack = () => navigate('/data-sources');

  const isSubmitting = updateLoading || validateLoading;

  if (queryLoading) return <Box sx={{display: 'flex', justifyContent: 'center', p:4}}><CircularProgress /></Box>;
  if (queryError) return <Alert severity="error">Error loading data for editing: {queryError.message}</Alert>;

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Box sx={{ mb: 2, flexShrink: 0 }}>
        <Button onClick={handleGoBack} startIcon={<img src="/icons/back-arrow.svg" alt="Back" style={{ width: '12px', height: '12px' }} />} sx={{ p: 0, textTransform: 'none', color: 'text.primary', '&:hover': { backgroundColor: 'transparent' } }}>
          <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px', marginLeft:'4px' }}>Edit Data Source</Typography>
        </Button>
        <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: '12px', color: 'rgba(102, 102, 102, 1)', mt: 0.5,marginRight:10, marginLeft:2 }}>Update your data source details.</Typography>
      </Box>

      <Paper elevation={0} sx={{ height: { md: 'calc(100vh - 180px)' }, minHeight: '650px', borderRadius: '10px', backgroundColor: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden', mt: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: theme.spacing(4), flexGrow: 1, overflow: 'auto' }}>
          <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: theme.spacing(3), padding: theme.spacing(3) }}>
            <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px' }}>Provider</Typography>
            <RadioGroup row value={selectedProvider} name="select-provider-group">
                {selectedProvider === 'google-cloud-platform' && <FormControlLabel value="google-cloud-platform" disabled control={<Radio sx={{ display: 'none' }} />} label={ <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 1, py: 1, borderRadius: '8px', border: '1px solid #0064FF', backgroundColor: '#F3F8FE', width: '255px', height: '35px', cursor: 'not-allowed', opacity: 0.8, marginLeft:1.2 }}> <img src="/icons/google-cloud-icon-2048x1646-7admxejz.svg" alt="GCP" style={{ height: 20, width: 20 }} /> <Typography sx={{ flexGrow: 1, fontSize: '12px', color: '#333333' }}>Google Cloud Platform</Typography> <Box sx={{ ml: 'auto', width: 16, height: 16, borderRadius: '50%', border: `1px solid #0064FF`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, '&::before': { content: '""', width: 8, height: 8, borderRadius: '50%', backgroundColor: '#0064FF' } }} /> </Box> } />}
                {selectedProvider === 'llm' && <FormControlLabel value="llm" disabled control={<Radio sx={{ display: 'none' }} />} label={ <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 1, py: 1, borderRadius: '8px', border: `1px solid #0064FF`, backgroundColor: alpha(theme.palette.primary.main, 0.05), width: '255px', height: '35px', cursor: 'not-allowed', opacity: 0.8, marginLeft:1.2 }}> <img src="/icons/llm-observability-blue.svg" alt="LLM" style={{ height: 18, width: 18}} /> <Typography sx={{ flexGrow: 1, fontSize: '12px' }}>LLM</Typography> <Box sx={{ ml: 'auto', width: 16, height: 16, borderRadius: '50%', border: `1px solid #0064FF`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, '&::before': { content: '""', width: 8, height: 8, borderRadius: '50%', backgroundColor: '#0064FF' } }} /> </Box> } />}
            </RadioGroup>
            <Divider />
            <Typography variant="h6" sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '14px', color:' #333333' }}> {selectedProvider === 'llm' ? 'LLM Details' : 'Billing Account Details'} </Typography>
            
            {selectedProvider === 'google-cloud-platform' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 0 }}>
                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 1.5 }}>
                        <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="dataSourceName" sx={externalLabelStyle}>Data Source Name *</InputLabel><TextField autoFocus required fullWidth id="dataSourceName" name="name" size="small" placeholder="Enter your data source name" sx={sxTextField} value={name} onChange={handleInputChange} error={!!fieldErrors.name} helperText={fieldErrors.name} InputProps={{ endAdornment: name && !fieldErrors.name && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}} /></Box>
                        <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="billingAccountId" sx={externalLabelStyle}>Billing Account ID *</InputLabel><TextField required fullWidth id="billingAccountId" name="billingAccountId" size="small" placeholder="Enter your GCP billing account ID" sx={sxTextField} value={billingAccountId} onChange={handleInputChange} error={!!fieldErrors.billingAccountId} helperText={fieldErrors.billingAccountId} InputProps={{ endAdornment: billingAccountId && !fieldErrors.billingAccountId && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}} /></Box>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 1.5 }}>
                        <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="bigQueryProjectId" sx={externalLabelStyle}>BigQuery Project ID *</InputLabel><TextField required fullWidth id="bigQueryProjectId" name="bigQueryProjectId" size="small" placeholder="Enter your BigQuery project ID" sx={sxTextField} value={bigQueryProjectId} onChange={handleInputChange} error={!!fieldErrors.bigQueryProjectId} helperText={fieldErrors.bigQueryProjectId} InputProps={{ endAdornment: bigQueryProjectId && !fieldErrors.bigQueryProjectId && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}} /></Box>
                        <Box sx={{ flex: 1, flexDirection: 'column' }}><InputLabel htmlFor="bigQueryDatasetId" sx={externalLabelStyle}>BigQuery Dataset ID *</InputLabel><TextField required fullWidth id="bigQueryDatasetId" name="bigQueryDatasetId" size="small" placeholder="Enter your BigQuery dataset ID" sx={sxTextField} value={bigQueryDatasetId} onChange={handleInputChange} error={!!fieldErrors.bigQueryDatasetId} helperText={fieldErrors.bigQueryDatasetId} InputProps={{ endAdornment: bigQueryDatasetId && !fieldErrors.bigQueryDatasetId && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}}/></Box>
                    </Box>
                    <Box sx={{ mt: 1.5, width:'49%' }}><InputLabel htmlFor="bigQueryDataTableName" sx={externalLabelStyle}>BigQuery Table Name *</InputLabel><TextField required fullWidth id="bigQueryDataTableName" name="bigQueryDataTableName" size="small" placeholder="Enter your BigQuery table name" sx={sxTextField} value={bigQueryDataTableName} onChange={handleInputChange} error={!!fieldErrors.bigQueryDataTableName} helperText={fieldErrors.bigQueryDataTableName} InputProps={{ endAdornment: bigQueryDataTableName && !fieldErrors.bigQueryDataTableName && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}}/></Box>
                </Box>
            )}
            {selectedProvider === 'llm' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 0 }}>
                    <Box sx={{ mt: 1.5, width: { xs: '100%', sm: 'calc(50% - 8px)' } }}>
                        <InputLabel htmlFor="dataSourceName" sx={externalLabelStyle}>Data Source Name *</InputLabel>
                        <TextField autoFocus required fullWidth id="dataSourceName" name="name" size="small" placeholder="Enter your data source name" sx={sxTextField} value={name} onChange={handleInputChange} error={!!fieldErrors.name} helperText={fieldErrors.name} InputProps={{ endAdornment: name && !fieldErrors.name && ( <CheckIcon sx={{ fontSize: '18px', color: '#03A65A' }} />)}} />
                    </Box>
                </Box>
            )}
          </Box>
          <Box sx={{ width: { xs: '100%', md: 320 }, flexShrink: 0, display: 'flex', flexDirection: 'column', backgroundColor:'rgba(243, 248, 254, 1)'}}>
              <Box sx={{ p: '15px', pb: 0, flexShrink: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',backgroundColor:'rgba(228, 240, 253, 1)', p: '12px', borderRadius: '4px' }}>
                    <Box sx={{ width :'250px', mr: 1 }}>
                        <Typography variant="h5" sx={{ fontSize:'12px',fontWeight: 600,mb:0.5 }}>Setup Guide</Typography>
                        <Typography variant="body2" sx={{ fontSize:'11px',fontWeight: 400 }}>Step-by-step guide to set up data access.</Typography>
                    </Box>
                    <img src="/icons/step-guide.svg" alt="Setup Guide" style={{ height: '70px', width: '70px', flexShrink: 0 }} />
                </Box>
              </Box>
            <Box sx={{ flexGrow: 1, overflowY: 'auto', p: '15px', pt: 2 }}>
                {selectedProvider === 'google-cloud-platform' && (
                  <>
                      {saLoading && <CircularProgress size={20} sx={{alignSelf: 'center'}} />}
                      {stepsData.map((item) => (
                          <Box sx={{ mb: 2 }} textAlign={'left'} key={item.step}>
                              <Typography variant="caption" sx={{ fontWeight: 600, color: 'primary.main', textTransform: 'uppercase' }}>{item.step}</Typography>
                              <Typography sx={{ fontSize: '12px', fontWeight: 600, whiteSpace: 'pre-line' }}>{item.title}</Typography>
                              <Typography variant="body2" sx={{ fontSize: '11px', color: 'text.secondary', whiteSpace: 'pre-line', wordBreak: 'break-word' }}>{item.description}</Typography>
                          </Box>
                      ))}
                      {saError && <Alert severity="error">Failed to get Service Account Email: {saError.message}</Alert>}
                  </>
                )}
                {selectedProvider === 'llm' && <LlmSetupGuide />}
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, p: 2, borderTop: 1, borderColor: 'divider', flexShrink: 0, mt: 'auto' }}>
            <Button variant="text" href="https://cloud.google.com/billing/docs/how-to/find-billing-account-id" target="_blank" rel="noopener noreferrer" sx={{ color:'rgba(0, 100, 255, 1)', mr: 'auto', textTransform: 'none', textDecoration: 'none' }} startIcon={<img src="/linkurl.svg" alt="Help icon" width="16" height="16"/>}>Where do I find my Billing Account ID?</Button>
            <Button sx={{ backgroundColor:' #F2F7FF',textTransform: 'none', fontFamily:'Inter', borderRadius:'8px',borderColor: '#0064FF', color:'#0064FF'}} onClick={() => navigate('/data-sources')}>Cancel</Button>
            <Button variant="contained" sx={{ textTransform: 'none', fontFamily:'Inter', borderRadius:'8px', backgroundColor: '#0064FF', color: '#FFFFFF' }} onClick={handleSubmit} disabled={!canSubmit || isSubmitting} startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}>
                {isSubmitting ? (updateLoading ? 'Saving...' : 'Validating...') : 'Save Changes'}
            </Button>
        </Box>
      </Paper>
      <Snackbar open={isToastOpen} autoHideDuration={6000} onClose={handleToastClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert icon={<CustomErrorIcon />} onClose={handleToastClose} sx={{ width: '100%', borderRadius: '50px', backgroundColor: 'white', boxShadow: theme.shadows[3], color: 'text.secondary', alignItems: 'center', p: theme.spacing(0.5, 2), '& .MuiAlert-message': { flex: 1, py: '12px' } }}>
          {toastMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default EditDataSourcesPage;